import { ChartHeader } from "components/dataVisualization/chartComponents/style";
import styled from "styled-components";

export const BidOfferChartHeader = styled(ChartHeader)`
  margin-bottom: 10px;
`;
